<template>
    <page-container class="contract-verify"
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item>
                <a>我要验签</a>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="header"
             v-if="!hideNavigate">
            <el-button class="grey-text small-font"
                       type="text"
                       @click="$router.push('/home')">&lt; 返回上一页</el-button>
        </div>

        <verify-upload :hide-navigate="hideNavigate"
                       :url="`${this.BASE_APP_PATH}/verify/start`"></verify-upload>

        <div class="horizonal-line"></div>

        <div class="verify-table">
            <p class="small-font">操作记录：
                    <el-popover trigger="hover">
                        <p class="grey-text">
                            验签记录仅展示7日
                        </p>
                        <span class="fr grey-text"
                              slot="reference">
                            <i class="el-icon-question"></i>帮助
                        </span>
                    </el-popover>
            </p>
            <el-table :data="logs"
                      border>
                <el-table-column label="文件名称"
                                 prop="name">
                    <template slot-scope="scope">
                        <span class="name-ellipsis"
                              :title="scope.row.name">
                            {{scope.row.name}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="签章数量"
                                 prop="signaturesNum"></el-table-column>
                <el-table-column label="是否有效">
                    <template slot-scope="scope">
                        <span :class="scope.row.pass ? 'green-text': 'red-text'">
                            {{scope.row.signaturesNum ? scope.row.pass ? '有效':'无效' : '/'}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="验签时间"
                                 prop="createTime"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary"
                                   size="small"
                                   @click="doViewDetail(scope.row.id)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination class="verify-page text-right"
                       background
                       @current-change="changePage"
                       :current-page.sync="filters.pageNo"
                       :page-size.sync="filters.pageSize"
                       layout="total, prev, pager, next"
                       :total="pageCount"></el-pagination>
    </page-container>
</template>

<script>
import PageContainer from "../../components/container.vue";
import VerifyUpload from "./childs/verify-upload.vue";

export default {
    name: "Verify",
    components: { PageContainer, VerifyUpload },
    data () {
        return {
            pageCount: 0,
            filters: {
                pageNo: 1,
                pageSize: 5,
            },
            logs: []
        };
    },
    props: {
        hideNavigate: Boolean
    },
    mounted () {
        this.getList();
    },
    methods: {
        // 获取表格数据
        async getList () {
            let loading = this.$loading({
                text: '加载中...'
            });
            try {
                let res = await this.axios({
                    url: "/verify/list",
                    method: "GET",
                    params: this.filters
                });
                if (res.data.code === 0) {
                    let datas = res.data.result;
                    datas = datas.map(data => {
                        data.name = data.name.split('.')[0];
                        return data;
                    });
                    this.logs = datas;
                    this.pageCount = res.data.page.totalCount;
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        // 页码变化
        changePage (pageNo) {
            this.filters.pageNo = pageNo;
            this.getList();
        },


        doViewDetail (id) {
            this.$router.push({ name: 'verifyResult', query: { id, hideNavigate: this.hideNavigate, hideFrame: this.hideNavigate } });
        }
    }
};
</script>
<style lang="less" scoped>
.contract-verify {
    .header {
        padding: 20px 20px 0;
    }
    .verify-table {
        margin: 0 auto;
        padding: 30px;
        .small-font {
            margin-bottom: 10px;
        }
    }

    .verify-page {
        padding: 0 30px 20px;
        text-align: right;
    }
}
</style>
